import { Linkedin } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useTheme } from "./ThemeContext";
import { QuiltLogo } from "./QuiltLogo";
import { DemoRequestDialog } from "./DemoRequestDialog";
import { PatientContactDialog } from "./PatientContactDialog";

// twitter, linkedin, instagram

export function Footer() {
  const { theme } = useTheme();
  // The patient page ("/") gets a patient contact form; every other page keeps the demo request form
  const isPatientPage = useLocation().pathname === "/";

  // 44px-tall tap targets on phones; compact on desktop
  const linkClass = `inline-flex min-h-11 items-center text-sm transition-colors md:min-h-0 ${theme === 'dark'
    ? "text-slate-500 hover:text-white"
    : "text-slate-600 hover:text-slate-900"
    }`;


  return (
    <footer className={theme === 'dark'
      ? "bg-black text-slate-400 py-8 border-t border-slate-900 relative z-100"
      : "bg-slate-50 text-slate-600 py-8 border-t border-slate-200 relative z-100"
    }>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-2 md:gap-6">
          <div className="flex items-center md:w-1/3 gap-3">
            <QuiltLogo variant="solid" alt="Quilt Technologies" className="w-8 h-8" />
            <span className={`${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>
              QUILT
            </span>
          </div>

          <div className="flex flex-wrap items-center justify-center md:w-1/3 gap-x-6">
            <Link to="/privacy" className={linkClass}>
              Privacy Policy
            </Link>
            <Link to="/terms" className={linkClass}>
              Terms & Conditions
            </Link>
            {isPatientPage ? (
              <PatientContactDialog>
                <button type="button" className={linkClass}>
                  Contact
                </button>
              </PatientContactDialog>
            ) : (
              <DemoRequestDialog triggerText="Schedule a Demo" source="provider_schedule_demo">
                <button type="button" className={linkClass}>
                  Contact
                </button>
              </DemoRequestDialog>
            )}

          </div>

          <div className="flex items-center md:justify-end md:w-1/3 gap-4">

            <a
              href="https://www.linkedin.com/company/quilttechnologies/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Quilt on LinkedIn"
              className={`inline-flex size-11 items-center justify-center md:size-auto ${theme === 'dark'
                ? "text-slate-500 hover:text-white transition-colors"
                : "text-slate-600 hover:text-slate-900 transition-colors"
                }`}
            >
              <Linkedin className="w-5 h-5" />
            </a>

          </div>
        </div>

        <div className="text-center mt-6">
          <p className={`text-sm ${theme === 'dark' ? 'text-slate-600' : 'text-slate-500'}`}>
            © 2026 Quilt Technologies. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
